import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getMachineTypes(page) {
  const data = await getFetch(`/MachineType?q=&page=${page}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeMachineTypes(form) {
  if (form.get('title') === '') {
    return {
      status: 'error',
      message: 'نوع دستگاه الزامی است!',
    }
  }

  const res = await postFetchWithToken("/MachineType/store", form);
  if(res.status !== 'error'){
    return {
      status:'success',
      message:'نوع دستگاه با موفقیت ایجاد شد'
    }
  }else{
    return {
      status:res.status,
      message:res.message
    }
  }
}
async function deleteMachineTypes(id) {
  const res = await postFetchWithBody(`/MachineType/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
export { getMachineTypes, storeMachineTypes,deleteMachineTypes };
